import { CreateFeedbackCommand } from '@models/ropolo';
import { ropoloRequest } from '../axios';

const getViewpointsList = async () => (await ropoloRequest.identityViewpointsList()).data;

const createFeedbacks = async (payload: CreateFeedbackCommand) =>
  (await ropoloRequest.identityFeedbacksCreate(payload)).data;

export { createFeedbacks, getViewpointsList };
